<template>
  <div
    :style="{ backgroundImage: 'url(' + image + ')' }"
    :class="'blocks-' + columns"
    class="default-blocks__block position-relative"
  >
    <span
      class="px-4 font-weight-bold text-dark text-uppercase text-center"
      :class="{'vloon': surroundingId === 1053}"
      v-html="title"
    />
      <i
        :style="{ backgroundColor: color }"
        class="fa fa-angle-right position-absolute"
    />
  </div>
</template>

<script>
export default {
  name: 'ec-business-block-item',
  props: {
    color: {
      type: String,
      default: ''
    },
    columns: {
      type: Number,
      default: 3
    },
    image: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    surroundingId: Number
  }
}
</script>
